export default "__VITE_ASSET__CwWcsh5B__"